const COMPONENT_EVENTS = {
  Load: {
    description: 'Triggered when user loads page',
    eventHub: {
      code: 'LOAD',
      action: 'On load'
    }
  }
};

const createEventAction = (eventAction, componentName) => {
  return [`${componentName ?? ''}`, `${eventAction ?? ''}`].filter((str) => !!str).join('_');
};

module.exports = {
  withdrawalApplicationComponentEvents: {
    WithdrawalSuccess: {
      code: 'WITHDRAWALSUCCESS',
      events: {
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Load.eventHub.action, 'WithdrawalSuccessPage')
          }
        },
        Done: {
          description: 'Triggered when user clicks on Done button',
          eventHub: {
            code: 'DONE',
            action: createEventAction('On click of Done', 'WithdrawalSuccessPage')
          }
        },
        CSL: {
          description: 'Triggered when user clicks on CSL card',
          eventHub: {
            code: 'CSL',
            action: createEventAction('Clicked CSL card', 'WithdrawalSuccessPage')
          }
        }
      }
    },
    WithdrawalVOE: {
      code: 'WithdrawalVOE',
      events: {
        Click: {
          description: `Triggered when user click button of What's a VOE `,
          eventHub: {
            code: 'OnClick',
            action: 'WithdrawalChildPage_WhatisVOE_Clicked'
          }
        },
        Load: {
          description: `Triggered when What's a VOE pop-up is loaded`,
          eventHub: {
            code: 'OnLoad',
            action: 'WithdrawalChildPage_WhatisVOE_Loaded'
          }
        }
      }
    },
    WithdrawalSampleVOE: {
      code: 'WithdrawalSampleVOE',
      events: {
        Click: {
          description: `Triggered when user click button of View Sample VOE `,
          eventHub: {
            code: 'OnClick',
            action: 'WithdrawalChildPage_ViewSampleVOE_Clicked'
          }
        },
        Load: {
          description: `Triggered when the VOE sample is loaded`,
          eventHub: {
            code: 'OnLoad',
            action: 'WithdrawalChildPage_VOESample_Loaded'
          }
        }
      }
    },
    WithdrawalAmount: {
      code: 'WithdrawalAmount',
      events: {
        Click: {
          description: `Triggered when user click of How much should I withdraw`,
          eventHub: {
            code: 'OnClick',
            action: 'WithdrawalAmount_HowMuchWithdraw_Clicked'
          }
        },
        Load: {
          description: `Triggered when the how much to withdraw page is loaded`,
          eventHub: {
            code: 'OnLoad',
            action: 'WithdrawalAmount_HowMuchWithdraw_Loaded'
          }
        }
      }
    }
  }
};
